import React, { useEffect, useState } from "react";
import { Locale } from "@linkfluence/models/locale";
import AutoComplete from "@ui-kit/form/autocomplete";
import { Choice, Status } from "@radarly/models/filters";

interface IProps {
  onSelect: (choice: Choice, status: Status) => void;
  choices: Choice[];
  placeholder?: string;
  locale?: Locale;
  noOptionMessage?: string;
  freeText?: boolean;
  visible?: boolean;
}
const FilterbarPanelsAutocomplete = ({
  onSelect,
  choices,
  placeholder,
  locale = Locale.English,
  noOptionMessage,
  freeText = false,
  visible = true,
}: IProps) => {
  const [firstMount, setFirstMount] = useState(visible);
  const [isFocused, setIsFocused] = useState(false);
  const [query, setQuery] = useState("");

  useEffect(() => {
    setFirstMount(visible);
    setIsFocused(visible);
  }, [visible]);

  return (
    <AutoComplete
      choices={choices}
      onSelect={onSelect}
      placeholder={placeholder}
      locale={locale}
      noOptionMessage={noOptionMessage}
      freeText={freeText}
      firstMount={firstMount}
      autoFocus={isFocused}
      onClickOutside={() => setFirstMount(false)}
      onQueryChange={setQuery}
      query={query}
    />
  );
};

export default FilterbarPanelsAutocomplete;
